import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { ElButton } from 'element-plus'

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'CandidateButton',
  props: {
    variant: { default: 'solid' },
    tone: { default: 'primary' },
    size: { default: 'medium' },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    nativeType: { default: 'button' },
    debounce: { type: [Boolean, Number], default: true }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



const props = __props

const emit = __emit

const elementType = computed(() => {
  if (props.tone === 'danger') return 'danger'
  if (props.tone === 'primary') return 'primary'
  return 'default'
})
const elementSize = computed(() => (props.size === 'medium' ? 'default' : props.size))

let locked = false

function handleClick(event: MouseEvent) {
  if (props.disabled || props.loading || locked) return
  const timeout =
    props.debounce === false || props.debounce === 0
      ? 0
      : typeof props.debounce === 'number'
        ? props.debounce
        : 300
  emit('click', event)
  if (timeout > 0) {
    locked = true
    window.setTimeout(() => {
      locked = false
    }, timeout)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElButton), _mergeProps({
    type: elementType.value,
    size: elementSize.value,
    plain: _ctx.variant === 'outline',
    text: _ctx.variant === 'text',
    disabled: _ctx.disabled,
    loading: _ctx.loading,
    "native-type": _ctx.nativeType,
    class: [
      'candidate-button',
      `candidate-button--${_ctx.variant}`,
      `candidate-button--${_ctx.tone}`,
      `candidate-button--size-${_ctx.size}`,
      { 'candidate-button--block': _ctx.block },
    ]
  }, _ctx.$attrs, { onClick: handleClick }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["type", "size", "plain", "text", "disabled", "loading", "native-type", "class"]))
}
}

})